<template>
  <div class="saleoutView">
    <vxe-layout-container vertical>
      <vxe-layout-header>
        <div
          style="display: flex; justify-content: flex-start; align-items: center;margin-top: 10px;margin-bottom: 10px;">
          <vxe-button mode="text" icon="vxe-icon-save" @click="handleSave" size="medium">保存</vxe-button>
          <vxe-button mode="text" icon="vxe-icon-search" @click="handlePriceQuery" size="medium">进价查询</vxe-button>
          <vxe-button mode="text" icon="vxe-icon-printer" @click="handlePrint" size="medium">打印单据</vxe-button>
          <vxe-button mode="text" icon="vxe-icon-delete" @click="handleDeleteRow" size="medium">删除行</vxe-button>
        </div>
        <div>
          <vxe-form ref="formRef" :data="formData" :rules="formRules" title-align="right" title-width="80px">
            <!-- 单号 -->
            <vxe-form-item title="单号" field="rkdh" :span="4">
              <template #default>
                <vxe-input v-model="formData.rkdh" placeholder="请输入单号"  class="form-input" :editable="false"/>
              </template>
            </vxe-form-item>

            <!-- 日期 -->
            <vxe-form-item title="日期" field="rq" :span="4">
              <template #default>
                <vxe-date-picker v-model="formData.rq" placeholder="请选择日期"  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd" class="form-input" />
              </template>
            </vxe-form-item>

            <!-- 开单人 -->
            <vxe-form-item title="开单人" field="jsr" :span="3">
              <template #default>
                <vxe-input v-model="formData.jsr" placeholder="请输入开单人"  class="form-input" />
              </template>
            </vxe-form-item>
 <!-- 开单人 -->
            <vxe-form-item  :span="13">
             
            </vxe-form-item>
            <!-- 供货商名称 -->
            <vxe-form-item title="供货商" field="gsmc" :span="8">
              <template #default>
                <vxe-input v-model="formData.gsmc" type="search" placeholder="请输入供货商名称" clearable @search-click="handleShowSearchSupplier"
  @keyup.enter="handleShowSearchSupplier"
                  class="form-input" />
              </template>
            </vxe-form-item>

            <!-- 收货仓库 -->
            <vxe-form-item title="收货仓库" field="ckbh" :span="6">
              <template #default>
                <vxe-input v-model="formData.ckbh" placeholder="请输入收货仓库"  class="form-input" />
              </template>
            </vxe-form-item>

           

            <!-- 含税 -->
            <vxe-form-item title="含税" field="hs" :span="3">
              <template #default>
                <vxe-select v-model="formData.hs" placeholder="请选择"  class="form-input">
                  <vxe-option value="未税" label="未税" />
                  <vxe-option value="含税" label="含税" />
                </vxe-select>
              </template>
            </vxe-form-item>

            <!-- 备注 -->
            <vxe-form-item title="备注" field="bz" :span="17">
              <template #default>
                <vxe-input v-model="formData.bz" placeholder="请输入备注信息" clearable class="form-input" />
              </template>
            </vxe-form-item>
          </vxe-form>
        </div>
      </vxe-layout-header>

      <vxe-layout-body>

        <vxe-table border show-footer ref="tableref" height="100%" :data="tableData" :footer-data="footerData"
          @current-change="handleCurrentChange" :edit-config="{ trigger: 'click', mode: 'row' }" 
          :cell-config="{ height: 30 }">
          <vxe-column field="seq" type="seq" width="70"></vxe-column>
          <vxe-column field="spbh" title="商品编号" :edit-render="{ name: 'input' }">
            <template #edit="{ row, rowIndex }">
              <vxe-input v-model="row.spbh" type="search" @search-click="ShowselectProductDialog(row, rowIndex)" 
                @keydown.enter="ShowselectProductDialog(row, rowIndex)"></vxe-input>
            </template>
          </vxe-column>
          <vxe-column field="fullname" title="全称"></vxe-column>
          <vxe-column field="unit" title="单位" width="70"></vxe-column>
          <vxe-column field="num" title="数量" show-overflow width="70" :edit-render="{ name: 'input' }">
            <template #edit="{ row }">
              <vxe-input v-model="row.num" @change="updateFootEvent"></vxe-input>
            </template>
          </vxe-column>
          <vxe-column field="price" title="单价" show-overflow width="70" :edit-render="{ name: 'input' }">
            <template #edit="{ row }">
              <vxe-input v-model="row.price" @change="updateFootEvent"></vxe-input>
            </template>
          </vxe-column>
          <vxe-column field="total" title="小计" show-overflow width="100">
            <template #default="{ row }">
              <span>￥{{ sumRowNum(row) }}</span>
            </template>
          </vxe-column>
          <vxe-column field="remarker" title="备注" show-overflow :edit-render="{ name: 'input' }"></vxe-column>

        </vxe-table>

      </vxe-layout-body>
    </vxe-layout-container>
    <!-- 选择商品* -->
    <vxe-modal v-model="showSelectproduct" width="60vw" height="60vh" destroy-on-close title="选择商品">
      <template #default>
        <selectProduct @select="handleSelectProduct" @cancel="showSelectproduct = false" :MnemonicPhraseProp="MnemonicPhrase">
        </selectProduct>
      </template>
    </vxe-modal>
    <!-- 选择供货商* -->
    <vxe-modal v-model="showSelectSupplier" width="60vw" height="60vh" destroy-on-close title="供货商选择">
      <template #default>
        <selectSupplier @select="handleSelectSupplier" @cancel="showSelectSupplier = false" :MnemonicPhraseProp="formData.Supplier">
        </selectSupplier>
      </template>
    </vxe-modal>
  </div>
</template>
<script setup>
import { reactive, defineProps, ref, onMounted } from 'vue'
import { sumRowNum, sumNum } from '../utils/calculate'
import selectProduct from '../components/selectComp/selectproductComp.vue'
import selectSupplier from '../components/selectComp/selectSupplierComp.vue'
import { CreateNewDocument, SaveDocument, GetDocDetail, GetOneDoc } from '../utils/BuyInDocHelper.js'
import { VxeUI } from 'vxe-pc-ui'
const showSelectproduct = ref(false)
const showSelectSupplier = ref(false)
const tableref = ref(null)
const rowindex = ref(0)
const usefule = ref('')
// 搜索供货商（打开弹窗并传递关键词）
const handleShowSearchSupplier = () => {
  // 如果有输入内容，可以将其作为搜索关键词传递给弹窗
  // 这里通过修改弹窗的 props 或触发事件来实现
  showSelectSupplier.value = true
}

const handleCurrentChange = (row, index) => {
  rowindex.value = index
}
// 在值发生改变时更新表尾合计
const updateFootEvent = () => {
  const $table = tableref.value
  if ($table) {
    const fullData = $table.getFullData()
    updateFootCount(fullData)
  }
}
const updateFootCount = (list) => {
  const [sumNObj] = footerData.value
  sumNObj.num = sumNum(list, 'num')
  let count = 0
  list.forEach((item) => {
    count += sumRowNum(item)
  })
  sumNObj.total = count.toFixed(2)
}

// ==================== Props ====================
const props = defineProps({
  initialData: {
    type: Object,
    default: () => ({ usefule: '新增', docNumber: '' })
  },

})

// ✅ 直接使用 props.initialData

// ==================== 表单数据 ====================
const formData = reactive({
  rkdh: props.initialData?.docNumber || CreateNewDocument("RKDH"),
  rq:  new Date(),
  jsr:  '许耀慧',
  ghsbh: '',
  ckbh: '东港店',
  hs:  '',
  bz:  '',
  hjje: 0,
  yhje: 0,
  bcfk: 0,
  syje: 0,
  zt: '未审核',
  gsmc: '',
})

// ==================== 表单验证规则 ====================
const formRules = reactive({
  rkdh: [{ required: true, message: '单号不能为空' }],
  rq: [{ required: true, message: '请选择日期' }],
  jsr: [{ required: true, message: '开单人不能为空' }],
  gsmc: [{ required: true, message: '供货商不能为空' }],
  ckbh: [{ required: true, message: '仓库不能为空' }],
   hs: [{ required: true, message: '请选择是否含税' }],
})
const tableData = ref([
])
const InitialData = (length) => { 
  for(let i = 0; i < length; i++)
   {
    tableData.value.push({
      spbh: '',
      fullname: '',
      unit: '',
      num: 0,
      price: 0,
      total: 0,
      remark: ''
    })
   }
  
}
onMounted(async () => {
  usefule.value = props.initialData.usefule
  if (usefule.value === '新增') {
    
    InitialData(20)
  }
  else {
      let res = await GetDocDetail(props.initialData.docNumber)
    if (res.length > 0) {
      res.forEach(item => {
        tableData.value.push({
          spbh: item.spbh,
          fullname: item.sP_QM,
          unit: item.sP_DW,
          num: item.sl,
          price: item.dj,
          total: item.hj,
          remark: item.bz
        })
      })
    }
     let doc=await GetOneDoc(props.initialData.docNumber)
    InitialData(20-tableData.value.length)
    Object.assign(formData,doc)
    formData.Supplier=doc.khmc
  }
})
// 表格数据
// const tableData = ref([{
//   productCode: '',
//   productName: '',
//   unit: '',
//   quantity: 0,
//   price: 0,
//   total: 0,
//   remark: ''
// }])
const editConfig = ref({
  trigger: 'click',
  mode: 'cell'
})
const MnemonicPhrase=ref('')
const ShowselectProductDialog = (row,rowIndex) => {

  MnemonicPhrase.value=row.spbh
  showSelectproduct.value = true
  rowindex.value = rowIndex
}
function handlePriceQuery() {
  emit('price-query')
}
const handleSelectSupplier = (data) => {
  try {
    if (data) {
      formData.ghsbh = data.bh
      formData.gsmc = data.gsmc
      showSelectSupplier.value = false
    }
  }
  catch (e) {
    alert(e)
  }
}
const handleSelectProduct = (data) => {
  try {
    const $table = tableref.value
    let index = rowindex.value
    // 如果 data 是数组，取第一个
    const selected = Array.isArray(data) ? data[0] : data

    if (!selected) return
    data.forEach((item, i) => {
      const row = tableData.value[index]
      if (row) {
        row.spbh = item.sP_BH || ''
        row.fullname = item.sP_MC || ''
        row.unit = item.sP_DW || ''
        row.num = 1
        row.price = 0
        row.total = row.num * row.price
        row.remarker = ''
        index += 1
      }
    })

    showSelectproduct.value = false
  }
  catch (e) {
    alert(e)
  }

}
function handlePrint() {
  emit('print')
}

function handleDeleteRow() {
  if (!safeTableData.value || safeTableData.value.length === 0) return

  const $table = tableRef.value
  if ($table) {
    const currRow = $table.getCurrentRow()
    if (currRow) {
      const index = tableData.value.indexOf(currRow)
      if (index > -1) {
        tableData.value.splice(index, 1)
        if (tableData.value.length === 0) {
          tableData.value.push(getDefaultRow())
        }

        return
      }
    }
  }

  if (tableData.value.length > 1) {
    const row = tableData.value.pop()

  } else {
    const row = tableData.value[0]
    Object.assign(row, getDefaultRow())
  }
}


const handleSave = async () => {
  if (usefule.value === '新增') {
    await SaveDocument(formData, tableData.value)

  }
  else {
    await SaveEditDocument(formData, tableData.value)
    usefule.value = '新增'
  }
// ✅ 保持响应式，只改属性
  Object.assign(formData, {
    rkdh: CreateNewDocument('RKDH'),
    rq: new Date(),
    jsr: '许耀慧',
    ghsbh: '',
    ckbh: '东港店',
    hs: '未税',
    bz: '',
    hjje: 0,
    yhje: 0,
    bcfk: 0,
    syje: 0,
    gsmc: ''
  })
    tableData.value = []
  InitialData(20)
  VxeUI.modal.message({
    id: 'myUniqueMsg',
    content: '保存成功',
    status: 'success'
  })



}
const footerData = ref([{ seq: '合计', num: '0', total: '0' }])
</script>
<style scoped>
.saleoutView {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.table-wrapper {
  flex: 1;
  min-height: 0;
  margin-top: 10px;
}
</style>